"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Bubble = exports.BubbleDefaultProps = void 0;
var React = __importStar(require("react")); // tslint:disable-line
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var icon_1 = require("./icon");
exports.BubbleDefaultProps = {
  color: 'dark',
  size: 32,
  iconScale: 0.7,
  iconColor: 'light',
  responsive: false,
  calc: function (size, breakpoint) {
    var multipliers = {
      base: 1.0,
      landscape: 1.0,
      tablet: 1.25,
      desktop: 1.5
    };
    var multipler = multipliers[breakpoint] || 1.0;
    return Math.round(multipler * size);
  }
};
// -------- Styles -------->
/**
 * Generates variable size styles based on the breakpoint name
 * @param name the breakpoint name
 */
var sizeFor = function (name, scale) {
  if (scale === void 0) {
    scale = 1.0;
  }
  return function (_a) {
    var calc = _a.calc,
      size = _a.size,
      responsive = _a.responsive;
    var calcSize = Math.round(scale * (responsive ? calc(size, name) : size));
    return (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    height: ", "px;\n    width: ", "px;\n  "], ["\n    height: ", "px;\n    width: ", "px;\n  "])), calcSize, calcSize);
  };
};
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n    border-radius: 50%;\n    ", ";\n    ", "\n  "], ["\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n    border-radius: 50%;\n    ", ";\n    ", "\n  "])), sizeFor('base'), function (props) {
    return props.color && (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      background-color: ", ";\n    "], ["\n      background-color: ", ";\n    "])), theme_1.theme.COLOR(props.color));
  }),
  landscape: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), sizeFor('landscape')),
  tablet: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), sizeFor('tablet')),
  desktop: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), sizeFor('desktop'))
});
var IconStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (props) {
    return (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), sizeFor('base', props.iconScale));
  }),
  landscape: (0, styled_components_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (props) {
    return (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), sizeFor('landscape', props.iconScale));
  }),
  tablet: (0, styled_components_1.css)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (props) {
    return (0, styled_components_1.css)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), sizeFor('tablet', props.iconScale));
  }),
  desktop: (0, styled_components_1.css)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (props) {
    return (0, styled_components_1.css)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), sizeFor('desktop', props.iconScale));
  })
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Icon: (0, styled_components_1.default)(icon_1.Icon)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), IconStyles)
};
var Bubble = function (props) {
  var children = props.children,
    className = props.className,
    color = props.color,
    size = props.size,
    iconColor = props.iconColor,
    responsive = props.responsive,
    calc = props.calc,
    iconScale = props.iconScale;
  return React.createElement(My.Container, {
    size: size,
    color: color,
    responsive: responsive,
    calc: calc,
    className: className
  }, React.createElement(My.Icon, {
    color: iconColor,
    iconScale: iconScale,
    size: size,
    responsive: responsive,
    calc: calc
  }, children));
};
exports.Bubble = Bubble;
exports.Bubble.defaultProps = exports.BubbleDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16;